import submitted from "./survey/submitted";
import delivery from "./survey/delivery";
import customer from "./survey/customer";
import deliveryfaq from "./survey/deliveryfaq";

export default {
    submitted,
    delivery,
    deliveryfaq,
    customer,
}